// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

export default class ClientVideoStreamReceivingReport {
  attendeeId: string;
  receivedAverageBitrateKbps: number;
  expectedAverageBitrateKbps: number;
}
